var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25867 9.79198C9.06667 9.97331 9.06667 10.2826 9.25867 10.464C9.44001 10.6453 9.74934 10.6453 9.93067 10.464L11.9893 8.39465L14.048 10.4533C14.2293 10.6346 14.5387 10.6346 14.72 10.4533C14.9013 10.2613 14.9013 9.95198 14.72 9.77065L12.3093 7.37065C12.2133 7.27465 12.096 7.22131 11.968 7.22131C11.84 7.22131 11.712 7.26398 11.6267 7.35998L9.22667 9.75998L9.25867 9.79198ZM14.7307 14.1973C14.912 14.0053 14.912 13.696 14.7307 13.5146C14.5387 13.3226 14.2293 13.3226 14.048 13.5146L11.9787 15.5733L9.90934 13.504C9.71734 13.312 9.40801 13.312 9.22667 13.504C9.03467 13.6853 9.03467 13.9946 9.22667 14.176L11.6267 16.576C11.808 16.7573 12.1173 16.7573 12.2987 16.576L14.6987 14.1653L14.7307 14.1973Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.5a9f362f8e66fffed2785e88baf7f05d.svg";
export { ForwardRef as ReactComponent };